"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import WaveDropPartContentMedias from "./WaveDropPartContentMedias";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import type { ReferencedNft } from "@/entities/IDrop";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import WaveDropPartContentMarkdown from "./WaveDropPartContentMarkdown";
import { ImageScale } from "@/helpers/image.helpers";
interface WaveDropPartContentProps {
  readonly mentionedUsers: ApiDropMentionedUser[];
  readonly mentionedWaves: ApiMentionedWave[];
  readonly referencedNfts: ReferencedNft[];
  readonly wave: ApiWaveMin;
  readonly activePart: ApiDropPart;
  readonly havePreviousPart: boolean;
  readonly haveNextPart: boolean;
  readonly isStorm: boolean;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly drop?: ApiDrop | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaImageScale?: ImageScale | undefined;
}
const WaveDropPartContent: React.FC<WaveDropPartContentProps> = t0 => {
  const $ = _c(38);
  const {
    mentionedUsers,
    mentionedWaves,
    referencedNfts,
    wave,
    activePart,
    havePreviousPart,
    haveNextPart,
    isStorm,
    activePartIndex,
    setActivePartIndex,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    drop,
    isCompetitionDrop: t3,
    mediaImageScale: t4
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const contentRef = React.useRef(null);
  const memoizedMentionedUsers = mentionedUsers;
  const memoizedMentionedWaves = mentionedWaves;
  const memoizedReferencedNfts = referencedNfts;
  let t5;
  if ($[0] !== activePartIndex || $[1] !== haveNextPart || $[2] !== havePreviousPart || $[3] !== setActivePartIndex) {
    t5 = direction => {
      const isPrevious = direction === "previous";
      const isDisabled = isPrevious ? !havePreviousPart : !haveNextPart;
      const onClick = () => setActivePartIndex(activePartIndex + (isPrevious ? -1 : 1));
      return <button disabled={isDisabled} className={`${isDisabled ? "tw-cursor-default tw-border-iron-700 tw-text-iron-700" : "tw-border-primary-400 tw-text-primary-400 hover:tw-bg-primary-400 hover:tw-text-white"} tw-flex tw-size-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-bg-transparent tw-transition tw-duration-300 tw-ease-out sm:tw-size-6`} onClick={e => {
        e.stopPropagation();
        onClick();
      }} aria-label={`${isPrevious ? "Previous" : "Next"} part`}><svg className="tw-size-5 tw-flex-shrink-0 sm:tw-size-4" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d={isPrevious ? "M15.75 19.5 8.25 12l7.5-7.5" : "m8.25 4.5 7.5 7.5-7.5 7.5"} /></svg></button>;
    };
    $[0] = activePartIndex;
    $[1] = haveNextPart;
    $[2] = havePreviousPart;
    $[3] = setActivePartIndex;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const renderNavigationButton = t5;
  let t6;
  if ($[5] !== isStorm || $[6] !== renderNavigationButton) {
    t6 = isStorm && <div className="tw-mb-3 tw-flex tw-justify-between tw-space-x-3 md:tw-hidden">{renderNavigationButton("previous")}{renderNavigationButton("next")}</div>;
    $[5] = isStorm;
    $[6] = renderNavigationButton;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isStorm || $[9] !== renderNavigationButton) {
    t7 = isStorm && <div className="tw-hidden md:tw-block">{renderNavigationButton("previous")}</div>;
    $[8] = isStorm;
    $[9] = renderNavigationButton;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== activePart || $[12] !== drop || $[13] !== isEditing || $[14] !== isSaving || $[15] !== memoizedMentionedUsers || $[16] !== memoizedMentionedWaves || $[17] !== memoizedReferencedNfts || $[18] !== onCancel || $[19] !== onQuoteClick || $[20] !== onSave || $[21] !== wave) {
    t8 = <div><WaveDropPartContentMarkdown mentionedUsers={memoizedMentionedUsers} mentionedWaves={memoizedMentionedWaves} referencedNfts={memoizedReferencedNfts} part={activePart} wave={wave} onQuoteClick={onQuoteClick} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} drop={drop} /></div>;
    $[11] = activePart;
    $[12] = drop;
    $[13] = isEditing;
    $[14] = isSaving;
    $[15] = memoizedMentionedUsers;
    $[16] = memoizedMentionedWaves;
    $[17] = memoizedReferencedNfts;
    $[18] = onCancel;
    $[19] = onQuoteClick;
    $[20] = onSave;
    $[21] = wave;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== activePart || $[24] !== isCompetitionDrop || $[25] !== mediaImageScale) {
    t9 = !!activePart.media.length && <WaveDropPartContentMedias activePart={activePart} isCompetitionDrop={isCompetitionDrop} imageScale={mediaImageScale} />;
    $[23] = activePart;
    $[24] = isCompetitionDrop;
    $[25] = mediaImageScale;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t8 || $[28] !== t9) {
    t10 = <div className="tw-h-full tw-w-full" ref={contentRef}>{t8}{t9}</div>;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== isStorm || $[31] !== renderNavigationButton) {
    t11 = isStorm && <div className="tw-hidden md:tw-block">{renderNavigationButton("next")}</div>;
    $[30] = isStorm;
    $[31] = renderNavigationButton;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t6 || $[36] !== t7) {
    t12 = <div className="tw-w-full"><div className="tw-flex tw-w-full tw-flex-col tw-justify-between md:tw-flex-row md:tw-gap-x-3">{t6}{t7}{t10}{t11}</div></div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t6;
    $[36] = t7;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
};
export default WaveDropPartContent;